import './index.css';

import React, { lazy } from 'react';
import { createRoot } from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { LoadingFallbackProvider } from './components/loadingFallback';
const App = lazy(() => import('./App'));

const rootElement = document.getElementById('root');

if (rootElement) {
  const root = createRoot(rootElement);

  root.render(
    <React.StrictMode>
      <LoadingFallbackProvider>
        <App />
      </LoadingFallbackProvider>
    </React.StrictMode>,
  );

  reportWebVitals();
}
